import { useState, useEffect } from 'react';
import Table from '../components/Users/Table';
import Content from '../components/Content';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../components/Jobs/Jobs.css';
import { Link } from 'react-router-dom';
import Skeleton from '../components/ui/Skeleton/Skeleton';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchUsers } from '../utils/api';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { UserInfoType } from '../types/AppTypes';

const Users = (): JSX.Element => {
  const { users, loading, message, error } = useAppSelector((state) => state.users);
  const [skeletonColumns] = useState(['Username', 'Groups']);
  const [skeletonRows] = useState([1, 2]);

  const userInfo = useSelector((state: RootState) => state.userInfo.userInfo) as UserInfoType;

  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchUsers(dispatch);
  }, []);

  if (error) {
    return (
      <div className="error">
        <span>{message}</span>
      </div>
    );
  }

  const permissions = userInfo?.permissions;

  return (
    <>
      {(permissions?.includes('users.create') || userInfo?.isAdmin )&& (
        <Link to="/user/add">
          <button
            type="button"
            className="add-button shadow bg-green-500 hover:bg-green-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4"
          >
            Add
          </button>
        </Link>
      )}
      <Content loading={false}>
        {loading ? <Skeleton columns={skeletonColumns} rows={skeletonRows} /> : <Table users={users} />}
      </Content>
    </>
  );
};

export default Users;
